// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAppConfig } from "../../config";


const app = initializeApp(getAppConfig().firebaseConfig);
const auth = getAuth(app);

export { auth };
